import { api } from '@shared/config/axios';

export default {
  getMemberships(params = {}) {
    return api.$get('/memberships', { params });
  },

  getMembership(uuid) {
    return api.$get(`/memberships/${uuid}`);
  },

  createMembership(membershipData) {
    return api.$post('/memberships', membershipData);
  },

  updateMembership(uuid, membershipData) {
    return api.$put(`/memberships/${uuid}`, membershipData);
  },

  deleteMembership(uuid) {
    return api.$delete(`/memberships/${uuid}`);
  },

  count() {
    return api.$get('/memberships/count');
  },

  checkActiveCustomerMemberships() {
    return api.$get('/memberships/check-active-customer-memberships');
  },

  getActiveCustomerMemberships() {
    return api.$get('/memberships/active-customer-memberships');
  },

  reorderMemberships(reorderedData) {
    return api.$put('/memberships/reordering', reorderedData);
  },

  // Membership Items API
  getMembershipItems(membershipUuid) {
    return api.$get(`/memberships/${membershipUuid}/items`);
  },

  addMembershipItem(membershipUuid, itemData) {
    return api.$post(`/memberships/${membershipUuid}/items`, itemData);
  },

  updateMembershipItem(membershipUuid, itemUuid, itemData) {
    return api.$put(
      `/memberships/${membershipUuid}/items/${itemUuid}`,
      itemData,
    );
  },

  removeMembershipItem(membershipUuid, itemUuid, propagateChanges = false) {
    // Use the more explicit `api.request` for DELETE with body to ensure compatibility.
    return api.request({
      url: `/memberships/${membershipUuid}/items/${itemUuid}`,
      method: 'delete',
      data: { propagate_changes: propagateChanges },
    });
  },

  reorderMembershipItems(membershipUuid, reorderData) {
    return api.$put(
      `/memberships/${membershipUuid}/items/reorder`,
      reorderData,
    );
  },

  syncMembershipItems(membershipUuid, payload) {
    return api.$put(`/memberships/${membershipUuid}/items/batch`, payload);
  },

  // Cleaner API like bundles
  addTraining(membershipUuid, trainingUuid, propagateChanges = false) {
    return api.$post(
      `/memberships/${membershipUuid}/trainings/${trainingUuid}`,
      { propagate_changes: propagateChanges },
    );
  },

  removeTraining(membershipUuid, trainingUuid, propagateChanges = false) {
    return api.request({
      url: `/memberships/${membershipUuid}/trainings/${trainingUuid}`,
      method: 'delete',
      data: { propagate_changes: propagateChanges },
    });
  },

  addBundle(membershipUuid, bundleUuid, propagateChanges = false) {
    return api.$post(`/memberships/${membershipUuid}/bundles/${bundleUuid}`, {
      propagate_changes: propagateChanges,
    });
  },

  removeBundle(membershipUuid, bundleUuid, propagateChanges = false) {
    return api.request({
      url: `/memberships/${membershipUuid}/bundles/${bundleUuid}`,
      method: 'delete',
      data: { propagate_changes: propagateChanges },
    });
  },

  // Price Management API
  createPrice(membershipUuid, priceData) {
    return api.$post(`/memberships/${membershipUuid}/prices`, priceData);
  },

  updatePrice(priceUuid, priceData) {
    return api.$put(`/prices/${priceUuid}`, priceData);
  },

  activatePrice(priceUuid) {
    return api.$put(`/prices/${priceUuid}/activate`);
  },

  archivePrice(priceUuid) {
    return api.$put(`/prices/${priceUuid}/archive`);
  },

  deletePrice(priceUuid) {
    return api.$delete(`/prices/${priceUuid}`);
  },
};
